import { render, staticRenderFns } from "./AddUpdateFolderModal.vue?vue&type=template&id=075a4154"
import script from "./AddUpdateFolderModal.vue?vue&type=script&lang=js"
export * from "./AddUpdateFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports